module.exports = __webpack_public_path__ + "media/site_templates/www.waterleakrepair.com.au/images/testimonials-858de2f5cc5a9adeb01e7e6258424a49.jpg";